import { render } from "./SocialVideoView.vue?vue&type=template&id=103e6330&scoped=true"
import script from "./SocialVideoView.vue?vue&type=script&lang=js"
export * from "./SocialVideoView.vue?vue&type=script&lang=js"

import "./SocialVideoView.vue?vue&type=style&index=0&id=103e6330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103e6330"]])

export default __exports__